// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import Invoice from "./invoice.js"
import InvoiceLine from "./invoice-line.js"
import Subscription from "./subscription.js"

const modelClassData = {
  "attributes": {
    "ends_at": {
      "column": {
        "default": null,
        "name": "ends_at",
        "null": false,
        "type": "date"
      },
      "name": "ends_at",
      "selected_by_default": null,
      "translated": null
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    },
    "starts_at": {
      "column": {
        "default": null,
        "name": "starts_at",
        "null": false,
        "type": "date"
      },
      "name": "starts_at",
      "selected_by_default": null,
      "translated": null
    },
    "subscription_id": {
      "column": {
        "default": null,
        "name": "subscription_id",
        "null": false,
        "type": "uuid"
      },
      "name": "subscription_id",
      "selected_by_default": null,
      "translated": null
    }
  },
  "className": "SubscriptionPeriod",
  "collectionKey": "subscription_periods",
  "collectionName": "subscription_periods",
  "i18nKey": "subscription_period",
  "camelizedLower": "subscriptionPeriod",
  "name": "SubscriptionPeriod",
  "nameDasherized": "subscription-period",
  "pluralName": "subscription_periods",
  "ransackable_associations": [
    {
      "className": "Invoice",
      "collectionName": "invoices",
      "foreignKey": "invoice_id",
      "name": "invoice",
      "macro": "has_one",
      "resource_name": "Invoice",
      "through": "invoice_line"
    },
    {
      "className": "InvoiceLine",
      "collectionName": "invoice_lines",
      "foreignKey": "invoice_line_id",
      "name": "invoice_line",
      "macro": "belongs_to",
      "resource_name": "InvoiceLine",
      "through": null
    },
    {
      "className": "Log",
      "collectionName": "logs",
      "foreignKey": "trackable_id",
      "name": "logs",
      "macro": "has_many",
      "resource_name": "Log",
      "through": null
    },
    {
      "className": "Subscription",
      "collectionName": "subscriptions",
      "foreignKey": "subscription_id",
      "name": "subscription",
      "macro": "belongs_to",
      "resource_name": "Subscription",
      "through": null
    },
    {
      "className": "SubscriptionRenewalGeneration",
      "collectionName": "subscription_renewal_generations",
      "foreignKey": "subscription_renewal_generation_id",
      "name": "subscription_renewal_generation",
      "macro": "belongs_to",
      "resource_name": "SubscriptionRenewalGeneration",
      "through": null
    },
    {
      "className": "Tagging",
      "collectionName": "taggings",
      "foreignKey": "resource_id",
      "name": "taggings",
      "macro": "has_many",
      "resource_name": "Tagging",
      "through": null
    },
    {
      "className": "Tag",
      "collectionName": "tags",
      "foreignKey": "tag_id",
      "name": "tags",
      "macro": "has_many",
      "resource_name": "Tag",
      "through": "taggings"
    },
    {
      "className": "Tenant",
      "collectionName": "tenants",
      "foreignKey": "tenant_id",
      "name": "tenant",
      "macro": "belongs_to",
      "resource_name": "Tenant",
      "through": null
    },
    {
      "className": "WorkerPlugins::WorkplaceLink",
      "collectionName": "workplace_links",
      "foreignKey": "resource_id",
      "name": "workplace_links",
      "macro": "has_many",
      "resource_name": "WorkplaceLink",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "ends_at",
      "column": {
        "default": null,
        "name": "ends_at",
        "null": false,
        "type": "date"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "id_string",
      "column": null
    },
    {
      "name": "invoice_line_id",
      "column": {
        "default": null,
        "name": "invoice_line_id",
        "null": true,
        "type": "uuid"
      }
    },
    {
      "name": "old_id",
      "column": {
        "default": null,
        "name": "old_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_invoice_line_id",
      "column": {
        "default": null,
        "name": "old_invoice_line_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_nemoa_id",
      "column": {
        "default": null,
        "name": "old_nemoa_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_subscription_id",
      "column": {
        "default": null,
        "name": "old_subscription_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_subscription_renewal_generation_id",
      "column": {
        "default": null,
        "name": "old_subscription_renewal_generation_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "starts_at",
      "column": {
        "default": null,
        "name": "starts_at",
        "null": false,
        "type": "date"
      }
    },
    {
      "name": "subscription_id",
      "column": {
        "default": null,
        "name": "subscription_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "subscription_renewal_generation_id",
      "column": {
        "default": null,
        "name": "subscription_renewal_generation_id",
        "null": true,
        "type": "uuid"
      }
    },
    {
      "name": "tenant_id",
      "column": {
        "default": null,
        "name": "tenant_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    }
  ],
  "ransackable_scopes": [
    {
      "name": "in_current_workplace"
    },
    {
      "name": "soft_deleted_filter"
    },
    {
      "name": "sort_by_in_current_workplace_asc"
    },
    {
      "name": "sort_by_in_current_workplace_desc"
    }
  ],
  "relationships": [
    {
      "className": "Invoice",
      "collectionName": "invoices",
      "foreignKey": "invoice_id",
      "name": "invoice",
      "macro": "has_one",
      "resource_name": "Invoice",
      "through": "invoice_line"
    },
    {
      "className": "InvoiceLine",
      "collectionName": "invoice_lines",
      "foreignKey": "invoice_line_id",
      "name": "invoice_line",
      "macro": "belongs_to",
      "resource_name": "InvoiceLine",
      "through": null
    },
    {
      "className": "Subscription",
      "collectionName": "subscriptions",
      "foreignKey": "subscription_id",
      "name": "subscription",
      "macro": "belongs_to",
      "resource_name": "Subscription",
      "through": null
    }
  ],
  "paramKey": "subscription_period",
  "primaryKey": "id"
}

/** Frontend model for SubscriptionPeriod. */
export default class SubscriptionPeriod extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {Date} */
  endsAt() {
    return this.readAttributeUnderscore("ends_at")
  }

  /** @returns {boolean} */
  hasEndsAt() {
    const value = this.endsAt()

    return this._isPresent(value)
  }

  /** @returns {string} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {Date} */
  startsAt() {
    return this.readAttributeUnderscore("starts_at")
  }

  /** @returns {boolean} */
  hasStartsAt() {
    const value = this.startsAt()

    return this._isPresent(value)
  }

  /** @returns {string} */
  subscriptionId() {
    return this.readAttributeUnderscore("subscription_id")
  }

  /** @returns {boolean} */
  hasSubscriptionId() {
    const value = this.subscriptionId()

    return this._isPresent(value)
  }

  /** @returns {import("./invoice.js").default | null} */
  invoice() {
    return this._readHasOneReflection({modelClass: Invoice, reflectionName: "invoice"})
  }

  /** @returns {Promise<import("./invoice.js").default | null>} */
  loadInvoice() {
    if (!("id" in this)) throw new Error("Primary key method wasn't defined: id")

    const id = this.id()

    return this._loadHasOneReflection(
      {
        reflectionName: "invoice",
        model: this,
        modelClass: Invoice
      },
      {
        params: {
          through: {
            model: "SubscriptionPeriod",
            id,
            reflection: "invoice"
          }
        }
      }
    )
  }

  /** @returns {Promise<import("./invoice.js").default | null>} */
  ensureInvoiceLoaded() {
    return this.ensureAssociationLoaded("invoice")
  }

  /** @returns {import("./invoice-line.js").default | null} */
  invoiceLine() {
    return this._readBelongsToReflection({modelClass: InvoiceLine, reflectionName: "invoice_line"})
  }

  /** @returns {Promise<import("./invoice-line.js").default | null>} */
  loadInvoiceLine() {
    if (!("invoiceLineId" in this)) throw new Error("Foreign key method wasn't defined: invoiceLineId")

    const id = this.invoiceLineId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "invoice_line",
        model: this,
        modelClass: InvoiceLine
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./invoice-line.js").default | null>} */
  ensureInvoiceLineLoaded() {
    return this.ensureAssociationLoaded("invoice_line")
  }

  /** @returns {import("./subscription.js").default | null} */
  subscription() {
    return this._readBelongsToReflection({modelClass: Subscription, reflectionName: "subscription"})
  }

  /** @returns {Promise<import("./subscription.js").default | null>} */
  loadSubscription() {
    if (!("subscriptionId" in this)) throw new Error("Foreign key method wasn't defined: subscriptionId")

    const id = this.subscriptionId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "subscription",
        model: this,
        modelClass: Subscription
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./subscription.js").default | null>} */
  ensureSubscriptionLoaded() {
    return this.ensureAssociationLoaded("subscription")
  }
}
